module.exports = __webpack_public_path__ + "img/step1.c1286b42.svg";